import styled from "styled-components";

import { Heading } from "../Heading";

const FooterHeading = styled(Heading)`
  text-transform: uppercase;
`;

FooterHeading.defaultProps = {
  mb: "12px",
  fontSize: 0,
  lineHeight: "12px",
  fontWeight: "semiBold",
  color: "footer.heading",
  as: "h4",
};

FooterHeading.displayName = "FooterHeading";

export default FooterHeading;
